import {Container} from "@mui/material";
import React from "react";
import {TitleAppBar} from "~/ui/AppBar/TitleAppBar";
import {ReleaseNoteList} from "~/release-notes/components/ReleaseNoteList";
import {useHistory} from "react-router-dom";


const ReleaseNotesPage = () => {
    const history = useHistory();

    const handleBackClick = () => {
        history.goBack();
    }

    return (
        <>
            <TitleAppBar onBack={handleBackClick} title="История изменений"/>
            <Container disableGutters style={{height: "calc(100vh - 56px)", marginTop: "56px", overflowY: "auto"}}>
                <ReleaseNoteList/>
            </Container>
        </>
    )
}


export default ReleaseNotesPage;